import React, { FC } from 'react';

import StatusIndicatorStep, { LC_STATUS_LABEL_LIVE_ON_LIBX } from './StatusIndicatorStep';

interface Props {
    live: boolean;
    highlighted: boolean;
    numberOfSteps: number;
}
const LibxStep: FC<Props> = props => {
    const { live, highlighted, numberOfSteps } = props;
    const liveAndHighlighted = live && highlighted;
    return (
        <StatusIndicatorStep
            fainted={true}
            numberOfSteps={numberOfSteps}
            enabled={live}
            highlighted={liveAndHighlighted}
            text={LC_STATUS_LABEL_LIVE_ON_LIBX}
        />
    );
};

export default LibxStep;
